import { render, staticRenderFns } from "./contentView.vue?vue&type=template&id=3537b2ea&scoped=true&"
import script from "./contentView.vue?vue&type=script&lang=js&"
export * from "./contentView.vue?vue&type=script&lang=js&"
import style0 from "./contentView.vue?vue&type=style&index=0&id=3537b2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537b2ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3537b2ea')) {
      api.createRecord('3537b2ea', component.options)
    } else {
      api.reload('3537b2ea', component.options)
    }
    module.hot.accept("./contentView.vue?vue&type=template&id=3537b2ea&scoped=true&", function () {
      api.rerender('3537b2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/servicePreview/components/contentView.vue"
export default component.exports